
export const headerHeight = 64;

export const sidebarWidth = 210;

export const sidebarWidthOnClose = 38;
